import * as React from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";

import styles from './style.css';
import LayoutComponentsHeartLoader from "../heart-loader";

// Same llama mark in both looks: purple on the white page, white on navy.
const LogoPurple = require('./icons/logo-purple.svg');
const LogoWhite = require('../../../../icons/logo-white.svg');

class LayoutComponentsLoaderProcessing extends React.PureComponent {

  static defaultProps = {
    opacity: .8,
    show: false,
  };

  static propTypes = {
    opacity: PropTypes.number,
    show: PropTypes.bool,
  };

  render() {
    const containerStyle = { backgroundColor: `rgba(var(--c-overlay-rgb), ${this.props.opacity})` };
    return (
      <CSSTransition
        in={this.props.show}
        timeout={400}
        classNames="fade"
        unmountOnExit
        mountOnEnter>
        <div className={styles.modalContainer} style={containerStyle}>
          <div className={styles.inner}>
            <div className={styles.brand}>
              <img src={LogoPurple} className={`${styles.logo} theme-base-only`} />
              <img src={LogoWhite} className={`${styles.logo} theme-memorial-only`} />
              <div className={styles.tagline}>We Deliver Emotion</div>
            </div>
            <LayoutComponentsHeartLoader/>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default LayoutComponentsLoaderProcessing;